export default {
      id: "ic_star-usage",
      viewBox: "0 0 12 11",
      url: "/" + "images/icons.3.109.2.svg#ic_star-usage",
      toString: function () {
        return this.url;
      }
    }